export default __webpack_public_path__ + "static/27-cyber-eye-ae8ad6a2ee52554d11a2022282ff1b79.png";